class PricingModule extends HTMLElement {
  bindEvents() {
    this.$toggle.addEventListener('click', this);
  }

  bindUI() {
    this.$subscriberDropdown = this.querySelector('subscriber-dropdown');
    this.$$pricingCards = this.querySelectorAll('.pricing-card');
    this.$toggle = this.querySelector('[data-ref="$pricingToggle"]');
  }

  connectedCallback() {
    this.setVars();
    this.bindUI();
    this.bindEvents();
  }

  /**
   * @param {InputEvent} event
   */
  handleEvent(event) {
    if (event.target === this.$toggle) {
      this.togglePricing();
    }
  }

  setVars() {
    this.showDiscount = true;
  }

  togglePricing() {
    this.showDiscount = !this.showDiscount;
    this.update();
  }

  update() {
    this.$$pricingCards.forEach(($pricingCard) => {
      $pricingCard.dataset.showDiscount = this.showDiscount;
    });

    if (this.$subscriberDropdown) {
      this.$subscriberDropdown.dataset.showDiscount = this.showDiscount;
    }

    this.$toggle.setAttribute('aria-pressed', this.showDiscount);
  }
}

if (!customElements.get('pricing-module')) {
  customElements.define('pricing-module', PricingModule);
}
